import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from './alertMessageSlice';

import TenantSettingService from '../services/tenantSetting.service';

export const getHomepageDetails = createAsyncThunk(
  'getHomepageDetails',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.getHomepageDetails(
        brandUser.tenant_id
      );
      return { data };
    } catch (error) {
      const message = error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getPersonalDetails = createAsyncThunk(
  'getPersonalDetails',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.personalDetails(
        brandUser.tenant_id,
        brandUser.user_details.user_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getPersonalDetailsOfTeamMember = createAsyncThunk(
  'getPersonalDetailsOfTeamMember',
  async (user_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.personalDetails(
        brandUser.tenant_id,
        user_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getTenantLogo = createAsyncThunk(
  'getTenantLogo',
  async (user_id, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.logoDetails(
        brandUser.tenant_id,
        brandUser.user_details?.user_id,
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const removeNumber = createAsyncThunk(
  'removeNumber',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.removeNumber(
        brandUser.tenant_id,
        brandUser.user_details.user_id,
        body
      );
      if(data?.status == 'success'){
        thunkAPI.dispatch(setMessage('Successfully updated details'));

      }
      thunkAPI.dispatch(getPersonalDetails());
      
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatePersonalDetails = createAsyncThunk(
  'updatePersonalDetails',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      await TenantSettingService.updatePersonalDetail(
        brandUser.tenant_id,
        brandUser.user_details.user_id,
        body
      );
      thunkAPI.dispatch(setMessage('Successfully updated details'));

      // ✅ FIX: await the re-fetch so we return FRESH data (with new logo URL)
      // instead of the stale update response
      const freshResult = await thunkAPI.dispatch(getPersonalDetails());
      const freshData = freshResult?.payload?.data;

      return { data: freshData };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updatePersonalDetailsOfTeamMember = createAsyncThunk(
  'updatePersonalDetailsOfTeamMember',
  async ({ user_per_id, ...body }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.updatePersonalDetail(
        brandUser.tenant_id,
        user_per_id,
        body
      );
      thunkAPI.dispatch(setMessage('Successfully updated details'));
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          ((error.response.data.detail || error.response.data.message) ||
            error?.response?.data?.detail?.[0]?.msg)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const companyBasicDetails = createAsyncThunk(
  'companyBasicDetails',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.getCompanyBasicDetails(
        brandUser.tenant_id
      );
      return { data };
    } catch (error) {
      const message = error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const teamMemberList = createAsyncThunk(
  'teamMemberList',
  async (thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      const data = await TenantSettingService.getTeamMembers(
        brandUser.tenant_id
      );
      return { data };
    } catch (error) {
      const message = error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getAllUserOf_A_Tenant = createAsyncThunk(
  'getAllUserOf_A_Tenant',
  async (tenant_id, thunkAPI) => {
    try {
      const data = await TenantSettingService.getAllUserOf_A_Tenant(
        tenant_id
      );
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.detail || error.response.data.message)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const removeMobile = createAsyncThunk(
  'removeMobile',
  async ({tenant_id,user_id,reason}, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      
      await TenantSettingService.removeMobile(tenant_id,user_id,reason,
                brandUser?.user_details.user_id,"brandadmin");
      // thunkAPI.dispatch(setMessage(`Tenant "${tenant_name}" deleted successfully`));
      // const data = await ExecutivePortalService.tenantManagementList();
      const data = await thunkAPI.dispatch(teamMemberList(tenant_id));
      thunkAPI.dispatch(setMessage("Mobile Number Removed Successfully"));
      
      return { data };
    } catch (error) {
      console.log(error,"error");
      
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.detail)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateTenantRole = createAsyncThunk(
  'updateTenantRole',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      console.log(body,"body");
      
      await TenantSettingService.updateTenantRole(body.tenant_id,body.user_id,body.role_id);
      // thunkAPI.dispatch(setMessage(`Tenant "${tenant_name}" deleted successfully`));
      // const data = await ExecutivePortalService.tenantManagementList();
      const data = await thunkAPI.dispatch(teamMemberList());
      await thunkAPI.dispatch(setMessage("Successfully updated the Role"));
      
      return { data };
    } catch (error) {
      console.log(error,"error");
      
      const message =
        (error.response &&
          error.response.data &&
          (error.response.data.message || error.response.data.detail)) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const deleteTeamMember = createAsyncThunk(
  'deleteTeamMember',
  async ({ user_id }, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));
      await TenantSettingService.deleteTeamMembers(
        brandUser.tenant_id,
        user_id
      );
      const data = await TenantSettingService.getTeamMembers(
        brandUser.tenant_id
      );
      return { data };
    } catch (error) {
      const message = error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const addTeamMember = createAsyncThunk(
  'addTeamMember',
  async (body, thunkAPI) => {
    try {
      const brandUser = JSON.parse(sessionStorage.getItem('brandUser'));

      const updatedArray = body.map((element) => {
        const user_name = element.userName;
        const first_name = element.firstName;
        const last_name = element.lastName;
        const password = element.password;
        const phone_number = element.phone_number;
        const country = element.country;
        const email_id = element.email;
        const role_id = element.role === 'Brand User' ? 200 : 100;
        const tenant_id = brandUser.tenant_id;

        return {
          user_name,
          first_name,
          last_name,
          password,
          phone_number,
          email_id,
          role_id,
          country,
          tenant_id,
        };
      });
      await TenantSettingService.addTeamMembers(
        updatedArray,
        brandUser.tenant_id
      );
      const data = await TenantSettingService.getTeamMembers(
        brandUser.tenant_id
      );
      return { data };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          (error?.response?.data?.message || error?.response?.data?.detail)) ||
        error?.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getPlansBillings = createAsyncThunk(
  'getPlansBillings',
  async (thunkAPI) => {
    try {
      const data = await TenantSettingService.getPlansBillings();
      return { data };
    } catch (error) {
      const message =
        (error?.response &&
          error?.response?.data &&
          (error?.response?.data?.message || error?.response?.data?.detail)) ||
        error?.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const acceptTerms = createAsyncThunk(
  'acceptTerms',
  async (tenant_id, thunkAPI) => {
    try {
      const data = await TenantSettingService.acceptTerms(tenant_id);
      return { data };
    } catch (error) {
      const message = error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  getHomepageDetailsData: null,
  personalDetailsData: null,
  getPersonalDetailsOfTeamMemberData: [],
  companyBasicDetailsData: null,
  getTenantLogoData: null,
  teamMemberListData: null,
  previewTheme: null,
  plansBillingsData: null,
};

const ExecutivePortalTenantManagementSlice = createSlice({
  name: 'tenantSettings',
  initialState,
  reducers: {

    setPersonalDetailsData: (state, action) => {
      state.personalDetailsData = action.payload;
    },
    setPreviewTheme: (state, action) => {
      state.previewTheme = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPersonalDetails.fulfilled, (state, action) => {
        state.personalDetailsData = action.payload.data;
      })
      .addCase(getPersonalDetails.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(updatePersonalDetails.fulfilled, (state, action) => {
        // ✅ FIX: now action.payload.data is the FRESH data from re-fetch
        if (action.payload?.data) {
          state.personalDetailsData = action.payload.data;
        }
      })
      .addCase(updatePersonalDetails.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(companyBasicDetails.fulfilled, (state, action) => {
        state.companyBasicDetailsData = action.payload.data;
      })
      .addCase(companyBasicDetails.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(teamMemberList.fulfilled, (state, action) => {
        state.teamMemberListData = action.payload.data;
      })
      .addCase(teamMemberList.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(deleteTeamMember.fulfilled, (state, action) => {
        state.teamMemberListData = action.payload.data;
      })
      .addCase(deleteTeamMember.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(addTeamMember.fulfilled, (state, action) => {
        state.teamMemberListData = action.payload.data;
      })
      .addCase(addTeamMember.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(getPlansBillings.fulfilled, (state, action) => {
        state.plansBillingsData = action.payload.data;
      })
      .addCase(getPlansBillings.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(getHomepageDetails.fulfilled, (state, action) => {
        state.getHomepageDetailsData = action.payload.data;
      })
      .addCase(getHomepageDetails.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(getPersonalDetailsOfTeamMember.fulfilled, (state, action) => {
        state.getPersonalDetailsOfTeamMemberData = action.payload.data;
      })
      .addCase(getPersonalDetailsOfTeamMember.rejected, (state, action) => {
        console.log('rejected');
      })
      .addCase(getTenantLogo.fulfilled, (state, action) => {
        state.getTenantLogoData = action.payload.data;
      })
      .addCase(getTenantLogo.rejected, (state, action) => {
        console.log('rejected');
        state.getTenantLogoData = null;

      })

      .addCase(updatePersonalDetailsOfTeamMember.fulfilled, (state, action) => {
        // const usernameToReplace = action.payload.data?.user_name;

        // state.getPersonalDetailsOfTeamMemberData =
        //   state.getPersonalDetailsOfTeamMemberData.map((user) =>
        //     user.user_name === usernameToReplace ? action.payload.data : user
        //   );
        // state.teamMemberListData = state.teamMemberListData.map((user) => {
        //   if (user.user_name === usernameToReplace) {
        //     user.first_name = action.payload.data?.first_name;
        //     user.email_id = action.payload.data?.email_id;
        //     return user;
        //   } else {
        //     return user;
        //   }
        // });
        state.getPersonalDetailsOfTeamMemberData = action.payload.data;
      })
      .addCase(updatePersonalDetailsOfTeamMember.rejected, (state, action) => {
        console.log('rejected');
      });
  },
});



export const {
    setPersonalDetailsData,
    setPreviewTheme
} = ExecutivePortalTenantManagementSlice.actions;

export default ExecutivePortalTenantManagementSlice.reducer;